<template>
  <div>
    <div>
      <div v-loading.fullscreen.lock="loading">
        <!-- 表单信息 -->
        <el-form
            :model="unit_memberForm"
            :rules="unit_memberRules"
            ref="unit_memberForm"
            class="unit_member_class"
            label-position="top"
            :disabled="form_disabled"
        >

          <!--          //基本信息-->
          <div v-show="activeName=='basic'">

            <template v-if="unit_memberForm.audit_status == 4">
              <el-row :gutter="24">
                <div style="width: 100%;position: relative">
            <span
                style="position: absolute;height: 100%;display: flex;align-items: center;left: 5px;color: #FFFFFF;font-size: 0.1rem">
              会员信息
            </span>
                  <img style="width: 100%" src="@/assets/line.png">
                </div>
              </el-row>
              <el-row :gutter="24">
                <!--              <el-col :span="8">-->
                <!--                <el-form-item label="单位名称" >-->
                <!--                  <el-input disabled v-model="unit_memberForm.company_name" placeholder="  "></el-input>-->
                <!--                </el-form-item>-->
                <!--              </el-col>-->
                <el-col :span="8">
                  <el-form-item label="登录手机号">
                    <el-input disabled v-model="unit_memberForm.account" placeholder="  "></el-input>
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label="会员代表">-->
                <!--                    <el-input disabled v-model="unit_memberForm.representative" placeholder="  "></el-input>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label="会员编号">
                    <el-input disabled v-model="unit_memberForm.member_code" placeholder="  "></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">

                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="所属委员会">
                    <el-select disabled v-model="unit_memberForm.committee_id" placeholder="">
                      <el-option
                          v-for="item in ccompanyList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位类型">
                    <el-select style="width: 100%" disabled v-model="unit_memberForm.level_long_id" placeholder="">
                      <el-option
                          v-for="item in MemberLevelList"
                          :key="item.level_long_id"
                          :label="item.level_name"
                          :value="item.level_long_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">

                </el-col>
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label="协会奖项">-->
                <!--                    <el-input disabled v-model="unit_memberForm.association_awards" placeholder=""></el-input>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="申请时间">
                    <el-input disabled v-model="unit_memberForm.join_time" placeholder="  "></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="入会时间">
                    <el-input disabled v-model="unit_memberForm.create_time" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="到期时间">
                    <el-input disabled v-model="unit_memberForm.due_time" placeholder=""></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="协会职务">
                    <el-input disabled v-model="unit_memberForm.association_position" placeholder="  "></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="委员会职务">
                    <el-input disabled v-model="unit_memberForm.committee_position" placeholder="  "></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">

                </el-col>
              </el-row>
            </template>


            <el-row :gutter="24" v-for="(items, indexs) in SheetData.basic" :key="indexs">
              <div v-if="items.title && items.display" style="width: 100%;position: relative">
            <span
                style="position: absolute;height: 100%;display: flex;align-items: center;left: 5px;color: #FFFFFF;font-size: 0.1rem">{{
                items.title
              }}</span>
                <img style="width: 100%" src="@/assets/line.png">
              </div>
              <el-col v-else :xl="item.xl?item.xl:8" :lg="item.lg?item.lg:8" v-for="(item, index) in items"
                      :key="index">
                <el-form-item v-if="item.display" :label="item.label" :prop="item.prop">
                  <template #label>
                    <span> {{ item.label }}</span>
                    <el-tooltip v-if="item.prop=='is_rules'" effect="dark" placement="top-start">
                      <div slot="content">
                        规模以上企业分为规模以上工业企业和规模以上商业企业。<br/>
                        规模以上工业企业是指年主营业务收入在2000万元<br/>
                        及以上的工业企业。<br/>
                        规模以上商业企业是指年商品销售额在2000万元及<br/>
                        以上的批发业企业（单位）和年商品销售额在500万<br/>
                        元及以上的零售业企业（单位）。
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </template>
                  <el-input
                      class="selitem"
                      v-if="item.assembly_type === 'input'"
                      v-model="unit_memberForm[item.prop]"
                      :placeholder="'请输入'+ item.label"
                      :type="item.type"
                      :disabled="item.disabled"
                  ></el-input>
                  <el-select
                      class="selitem"
                      v-if="item.assembly_type === 'el_option'"
                      v-model="unit_memberForm[item.prop]"
                      :placeholder="'请选择'+ item.label"
                      clearable
                      :disabled="item.disabled"
                      @change="(e)=>{return el_option_change(e, item.prop)}"
                  >
                    <el-option
                        v-for="every in item.options"
                        :key="every.value"
                        :label="every.name"
                        :value="every.value"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                      class="selitem"
                      v-if="item.assembly_type === 'date'"
                      :type="item.type"
                      :placeholder="'请选择'+item.label"
                      value-format="yyyy-MM-dd"
                      v-model="unit_memberForm[item.prop]"
                  >
                  </el-date-picker>
                  <el-cascader
                      class="selitem"
                      v-if="item.assembly_type === 'el_cascader'"
                      v-model="unit_memberForm[item.prop]"
                      :options="item.options"
                      clearable
                      :disabled="item.disabled"
                  >
                  </el-cascader>
                  <el-input
                      class="selitem"
                      show-word-limit
                      rows="4"
                      v-if="item.assembly_type === 'input_textarea'"
                      v-model="unit_memberForm[item.prop]"
                      :placeholder="'请输入'+ item.prompt"
                      :type="item.type"
                      :disabled="item.disabled"
                  ></el-input>
                  <template v-if="item.assembly_type === 'el_checkbox'">
                    <el-checkbox-group
                        v-model="unit_memberForm[item.prop]"
                    >
                      <el-checkbox v-for="(check_item,check_index) in item.options" :label="check_item.name"
                                   :key="check_index"
                                   @change="handleCheckedChange"
                      >
                      </el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="item.assembly_type === 'image_up'">
                    <div class="image" v-if="unit_memberForm[item.prop]&&unit_memberForm[item.prop].length>0">
                      <el-image :src="$imgUrl+unit_memberForm[item.prop]"></el-image>
                      <div class="upload-span">
                  <span class="upload-icon" @click.stop="handlePreview(unit_memberForm[item.prop])"><i
                      class="el-icon-zoom-in"></i></span>
                        <span class="upload-icon" @click.stop="handleRemove(item.prop)" style="margin-left: 20px"><i
                            class="el-icon-delete"></i></span>
                      </div>
                    </div>
                    <div v-if="!unit_memberForm[item.prop]">
                      <el-upload
                          :action="$Url"
                          list-type="picture-card"
                          :headers="headers"
                          :multiple="false"
                          :on-success="(response, file, fileList) => {return handleSuccess(response, file, fileList, item.prop)}"
                          :on-error="handleError"
                          :show-file-list="false">
                        <i class="el-icon-plus">
                          <div class="uploadtxt">{{ item.prompt }}</div>
                        </i>
                      </el-upload>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
                v-if="SheetData.basic[SheetData.basic.length-1].title=='品牌' && SheetData.basic[SheetData.basic.length-1].display"
                class="tableBox">
              <el-col :xl="24" :lg="24">
                <!--            <div class="btnBox">-->
                <!--              <div class="searchBtnBox">-->
                <!--                <div class="main-title">品牌列表</div>-->
                <!--                <button class="btn search-btn" @click="changeBrand('add','')">创建品牌</button>-->
                <!--              </div>-->
                <!--            </div>-->
                <div class="invitate-wrap">
                  <!-- 列表 -->
                  <div class="invitation-table">
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        border
                        :cell-style="{textAlign: 'center'}"
                        :header-cell-style="{background:'#EDF1F7',color: '#333', textAlign: 'center'}"
                    >
                      <el-table-column
                          prop="ownership_type"
                          label="所属类型">
                        <template v-slot="scope">
                          {{ scope.row.ownership_type == 1 ? '个人会员' : '单位会员' }}
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="brand_name"
                          label="品牌名称">
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="brand_type"-->
                      <!--                          label="品牌类别">-->
                      <!--                      </el-table-column>-->
                      <!--                  <el-table-column-->
                      <!--                      prop="registration_time"-->
                      <!--                      label="注册时间">-->
                      <!--                  </el-table-column>-->
                      <el-table-column
                          prop="registration_address"
                          label="注册地">
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="offline_store"-->
                      <!--                          label="线下分布">-->
                      <!--                      </el-table-column>-->
                      <!--                      <el-table-column-->
                      <!--                          prop="SKU"-->
                      <!--                          label="年SKU数">-->
                      <!--                      </el-table-column>-->
                      <el-table-column
                          prop="category"
                          label="品类"
                          width="250"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="honors"
                          label="奖项及荣誉"
                          width=""
                      >
                      </el-table-column>
                      <el-table-column
                          fixed="right"
                          label="操作"
                          width="120">
                        <template v-slot="scope">
                          <el-button
                              @click.native.prevent="changeBrand('edit',scope.row)"
                              type="text"
                              size="small">
                            编辑
                          </el-button>
                          <el-button
                              @click.native.prevent="delRow(scope.row)"
                              type="text"
                              style="color: red"
                              size="small">
                            删除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>

                  </div>
                </div>
                <div style="text-align: center;margin: 20px">
                  <button class="btn search-btn" @click.prevent="changeBrand('add','')" style="font-size: 18px">
                    添加品牌
                  </button>

                </div>
                <!--            <div class="paginationbox">-->
                <!--              <el-pagination-->
                <!--                  @size-change="handleSizeChange"-->
                <!--                  @current-change="handleCurrentChange"-->
                <!--                  :current-page="page_no"-->
                <!--                  :page-sizes="[10, 20, 30, 50]"-->
                <!--                  :page-size="page_size"-->
                <!--                  layout="total, sizes, prev, pager, next, jumper"-->
                <!--                  :total="total">-->
                <!--              </el-pagination>-->
                <!--            </div>-->
              </el-col>
            </el-row>
          </div>

        </el-form>
        <!--        <div class="bus-btn">-->
        <!--          <el-button class="save-draft" @click="submitForm('unit_memberForm', 'draft')"-->
        <!--          >保存-->
        <!--          </el-button>-->
        <!--          <el-button @click="submitForm('unit_memberForm', 'submit')"-->
        <!--          >提交-->
        <!--          </el-button-->
        <!--          >-->
        <!--        </div>-->
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" top="20vh">
      <img
          :src="dialogImageUrl"
          alt=""
          style="
            max-height: 550px;
            max-width: 100%;
            margin: 0 auto;
            display: block;
          "
      />
    </el-dialog>
    <!-- 赵 品牌新增/编辑 -->
    <el-dialog :title="brandTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="700px">
      <el-form :model="brandForm" :rules="brandFormRules" ref="brandFormRef" label-position="top">
        <el-form-item label="品牌名称" prop="brand_name">
          <el-input v-model="brandForm.brand_name" placeholder="请输入品牌名称"></el-input>
        </el-form-item>
        <el-form-item label="品牌官网" prop="website">
          <el-input v-model="brandForm.website" placeholder="请输入品牌官网"></el-input>
        </el-form-item>
        <el-form-item label="品牌归属" prop="brand_type">
          <el-select v-model="brandForm.brand_type" placeholder="请选择品牌归属" class="selitem">
            <el-option
                v-for="every in inbrand_type_options"
                :key="every.value"
                :label="every.name"
                :value="every.value"
            >
            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="注册时间" prop="registration_time">
          <el-date-picker type="date" placeholder="选择注册时间" value-format="yyyy-MM-dd"
                          v-model="brandForm.registration_time"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="注册地" prop="registration_address">
          <el-input v-model="brandForm.registration_address" placeholder="请输入注册地"></el-input>
        </el-form-item>
        <el-form-item label="商标注册证/代理授权" prop="logo" style="width:100%">
          <div class="image" v-if="brandForm.trademark&&brandForm.trademark.length>0">
            <el-image :src="$imgUrl+brandForm.trademark"></el-image>
            <div class="upload-span">
              <span class="upload-icon" @click.stop="handlePreview(brandForm.trademark)"><i
                  class="el-icon-zoom-in"></i></span>
              <span class="upload-icon" @click.stop="trademarkRemove()" style="margin-left: 20px"><i
                  class="el-icon-delete"></i></span>
            </div>
          </div>

          <div v-else>
            <el-upload
                :action="$Url"
                list-type="picture-card"
                :headers="headers"
                :multiple="false"
                :on-success="trademarkSuccess"
                :on-error="trademarkError"
                :show-file-list="false">
              <i class="el-icon-plus">
                <div class="uploadtxt">pdf文件或图片均可，大小在500kb以内</div>
              </i>
            </el-upload
            >
          </div>
        </el-form-item>
        <el-form-item label="品类" prop="category">
          <template>
            <div>服装</div>
            <el-checkbox-group v-model="checkCategory">
              <el-checkbox v-for="(item,index) in member_clothing" :label="item.name" :key="index"
                           @change="handleCheckedChange"
              >{{ item.value }}
              </el-checkbox>
            </el-checkbox-group>
            <el-input v-if="Clothing_Other" v-model="Clothing_Other_text" placeholder="请输入其他服装品类"></el-input>
          </template>
          <template>
            <div>配饰</div>
            <el-checkbox-group v-model="checkCategory">
              <el-checkbox v-for="(item,index) in member_ornament" :label="item.name" :key="index"
                           @change="handleCheckedChange"
              >{{ item.value }}
              </el-checkbox>
            </el-checkbox-group>
            <el-input v-if="Accessories_Other" v-model="Accessories_Other_text"
                      placeholder="请输入其他配饰品类"></el-input>
          </template>

          <!--            <el-select v-model="brandForm.category" placeholder="请选择品类" multiple class="selitem">-->
          <!--              <el-option-->
          <!--                  v-for="every in category_options"-->
          <!--                  :key="every.value"-->
          <!--                  :label="every.name"-->
          <!--                  :value="every.value"-->
          <!--              >-->
          <!--              </el-option>-->
          <!--            </el-select>-->
        </el-form-item>
        <el-form-item label="线下分布" prop="offline_store">
          <el-input
              v-model="brandForm.offline_store"
              type="textarea" rows="4" clearable
              placeholder="自营店数量城市及商业名称：（如北京skp、北京合生汇）加盟/代理店数量：城市及商业名称：入驻买手店/集合店/showroom数量：城市及名称：无"
              class="selitem"
          ></el-input>
        </el-form-item>
        <el-form-item label="入驻电商平台" prop="online_store">
          <!--          <el-select v-model="brandForm.online_store" placeholder="请选择入驻电商平台" multiple class="selitem">-->
          <!--            <el-option-->
          <!--                v-for="every in member_platform"-->
          <!--                :key="every.value"-->
          <!--                :label="every.name"-->
          <!--                :value="every.value"-->
          <!--            >-->
          <!--            </el-option>-->

          <!--          </el-select>-->
          <el-checkbox-group v-model="checkOnline_store">
            <el-checkbox v-for="(item,index) in member_platform" :label="item.name" :key="index"
                         @change="handleCheckedChange"
            >{{ item.value }}
            </el-checkbox>
          </el-checkbox-group>
          <el-input v-if="E_commerce_Other" v-model="E_commerce_Other_text"
                    placeholder="请输入其他入驻电商平台"></el-input>
        </el-form-item>
        <el-form-item label="其他销售渠道" prop="">
          <el-input v-model="brandForm.sales_channel" placeholder="请输入其他销售渠道"></el-input>
        </el-form-item>
        <el-form-item label="年SKU数" prop="SKU">
          <el-input v-model="brandForm.SKU" placeholder="请输入年SKU数"></el-input>
        </el-form-item>
        <el-form-item label="产品价位" prop="product_price">
          <el-input v-model="brandForm.product_price" placeholder="请输入产品价位"></el-input>
        </el-form-item>
        <el-form-item label="奖项及荣誉" prop="honors">
          <el-input
              v-model="brandForm.honors"
              type="textarea" rows="4" clearable
              placeholder="如：中国驰名商标 2024年度时尚品牌奖"
              class="selitem"
          ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="btn" @click="dialogFormVisible = false">取 消</button>
        <button class="btn next_btn next" @click="brandFormsave">确 定</button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  companyType,
  draft,
  submitCompanyInfo,
  optionList,
  addContacts,
  editContacts,
  getContactsDetail,
  MemberBrand_edit,
  MemberBrand_add,
  MemberBrand_delete,
  MemberBrand_detail,
  MemberBrandLists,
  MemberLevel_lists,
} from "@/api/api";
import {area} from "../utils/area";
import fa from "element-ui/src/locale/lang/fa"; //国家地区
export default {
  props: ["activeName", 'SheetData', 'form_data'],
  components: {},
  name: "busInformation",
  data() {
    return {
      ccompanyList: JSON.parse(localStorage.getItem('ccompanyList')),
      tableData: [],
      total: 1,
      page_no: 1,
      page_size: 10,
      form_disabled: false,
      dialogFormVisible: false,//品牌弹窗
      committee_text_show: false,//富文本弹窗
      brandTitle: "",//品牌弹窗名称
      brandForm: {//品牌表单数据
        id: "",//品牌id
        ownership: "",//所属类型 1:个人会员，2:单位会员
        user_long_id: "",//所关联的用户长ID
        brand_name: "",//品牌名称
        website: "",//品牌官网
        brand_type: "",//品牌类别
        registration_time: "",//注册时间
        registration_address: "",//注册地
        trademark: [],//商标注册证或代理授权
        category: "",//品类
        offline_store: "",//线上分布/线上店铺
        online_store: "",//入驻电商平台
        SKU: "",//年sku数
        product_price: "",//产品及价位
        honors: "",//奖项及荣誉
      },
      checkCategory: [],
      checkOnline_store: [],
      Clothing_Other: false,
      Accessories_Other: false,
      E_commerce_Other: false,
      Clothing_Other_text: '',
      Accessories_Other_text: '',
      E_commerce_Other_text: '',

      brandFormRules: {//品牌表单验证
        brand_name: [
          {required: true, message: '请输入品牌名称', trigger: ['blur', 'change']},
        ],
        brand_type: [
          {required: true, message: '请选择品牌归属', trigger: ['blur', 'change']},
        ],
        registration_time: [
          {required: true, message: '请选择注册时间', trigger: ['blur', 'change']},
        ],
        registration_address: [
          {required: true, message: '请输入注册地', trigger: ['blur', 'change']},
        ],
        offline_store: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
        ],
        online_store: [
          {required: true, message: '请选择入驻电商平台', trigger: ['blur', 'change']},
        ],
        category: [
          {required: true, message: '请选择品类', trigger: ['blur', 'change']},
        ],
        SKU: [
          {required: true, message: '请输入年SKU数', trigger: ['blur', 'change']},
        ],
        product_price: [
          {required: true, message: '请输入产品价位', trigger: ['blur', 'change']},
        ],
        honors: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
        ],
      },
      inbrand_type_options: JSON.parse(localStorage.getItem('dictdata')).belong_brand,
      member_clothing: JSON.parse(localStorage.getItem('dictdata')).member_clothing,
      member_ornament: JSON.parse(localStorage.getItem('dictdata')).member_ornament,
      category_options: JSON.parse(localStorage.getItem('dictdata')).member_brand_category,
      member_platform: JSON.parse(localStorage.getItem('dictdata')).member_platform,
      Url: '',
      type: '',
      userdata: {},
      active: 1,
      headers: {
        token: localStorage.getItem("token")
      },
      loading: false,
      // online_business_plat_other: "", //其他线上业务平台
      unit_memberForm: {
        type: 2,
        committee_id: 0,
        committee_title: "",
        company_name: "",
        established_time: "",
        business_license: "",
        representative: "",
        representative_IDCard: "",
        representative_position: "",
        representative_mobile: "",
        representative_mobile_wechat: 1,
        contacts: "",
        contacts_position: "",
        contacts_mobile: "",
        contacts_mobile_wechat: '',
        company_size: "",
        company_website: "",
        company_Introduction: "",
        company_type: "",
        company_wish: "",
        is_rules: 1,
        performance: "",
        brands_count: "3",
        first_discipline: "",
        secondary_discipline: "",
        students_count: "",
        teachers_count: "",
        that_stage: "",
        business_introduction: "",
        settled_count: "",
        models_signed_count: "",
        models_proxy_count: "",
        institution_introduction: "",
        large_projects: "",
        business_photos: "",
        printed_materials: "",
        professional_achievement: "",
        suggestion: "",
        major_name: "",
        major_introduction: "",
        graduates_count: '',
        readers_count: '',
        average_age: '',
        average_height: '',
        employment_situation: "",
        teaching_photos: "",
        training_type: "",
        enrollment_status: "",
        level_long_id: ""

      },
      unit_memberRules: {
        company_name: [{required: true, message: "请输入单位名称", trigger: ['blur', 'change']}],
        established_time: [{required: true, message: "请选择成立时间", trigger: ['blur', 'change']}],
        representative: [{required: true, message: "请输入会员代表", trigger: ['blur', 'change']}],
        first_discipline: [{
          required: true,
          message: "请输入服装、配饰、时尚相关专业一级学科数量",
          trigger: ['blur', 'change']
        }],
        secondary_discipline: [{
          required: true,
          message: "请输入服装、配饰、时尚相关专业二级学科数量",
          trigger: ['blur', 'change']
        }],
        students_count: [{
          required: true,
          message: "请输入服装、配饰、时尚相关专业在校生人数",
          trigger: ['blur', 'change']
        }],
        teachers_count: [{
          required: true,
          message: "请输入服装、配饰、时尚相关专业教职工人数",
          trigger: ['blur', 'change']
        }],
        representative_position: [{required: true, message: "请输入会员代表职务", trigger: ['blur', 'change']}],
        contacts: [{required: true, message: "请输入联系人", trigger: ['blur', 'change']}],
        contacts_position: [{required: true, message: "请输入联系人职务", trigger: ['blur', 'change']}],
        contacts_mobile: [{required: true, message: "请输入联系人联系方式", trigger: ['blur', 'change']}],
        brands_count: [{required: true, message: "请输入集团下品牌数量", trigger: ['blur', 'change']}],
        representative_mobile_wechat: [{
          required: true,
          message: "请选择会员代表联系方式与微信是否同步",
          trigger: ['blur', 'change']
        }],
        represent_email: [{required: true, message: "请输入会员代表邮箱", trigger: ['blur', 'change']}],
        contacts_email: [{required: true, message: "请输入联系人邮箱", trigger: ['blur', 'change']}],
        company_size: [{required: true, message: "请输入单位规模（人数）", trigger: ['blur', 'change']}],
        is_rules: [{required: true, message: "请选择是否为规上企业", trigger: ['blur', 'change']}],
        performance: [{required: true, message: "请输入经济状况", trigger: ['blur', 'change']}],
        that_stage: [{
          required: true,
          message: "请输入企业处于纺织服装及时尚产业的哪个环节",
          trigger: ['blur', 'change']
        }],
        city: [
          {required: true, message: '请选择省市区', trigger: ['blur', 'change']},
        ],
        business_introduction: [{required: true, message: "请输入企业主营业务介绍", trigger: ['blur', 'change']}],
        company_Introduction: [{required: true, message: "请输入单位简介", trigger: ['blur', 'change']}],
        business_license: [{required: true, message: "请上传营业执照", trigger: ['blur', 'change']}],
        representative_IDCard: [{required: true, message: "请输入会员代表身份证", trigger: ['blur', 'change']}],
        representative_mobile: [{required: true, message: "请输入会员代表联系方式", trigger: "blur"}],
        settled_count: [{required: true, message: "请输入入驻企业数量", trigger: "blur"}],
        suggestion: [{required: true, message: "请输入对模特行业现状的看法和建议", trigger: "blur"}],
        telephone: [{required: true, message: "请输入固话", trigger: "blur"}],
        email: [{required: true, message: "请输邮箱", trigger: "blur"}, {
          type: "email",
          message: "请输入正确的邮箱地址",
          trigger: ["blur", "change"],
        },
        ],
        mobile: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号码格式不正确",
          trigger: "blur",
        },
        ],
        position: [{required: true, message: "请输入职位", trigger: "blur"}],
        magazine_reception: [{required: true, message: "请选择杂志接收方式", trigger: ['blur', 'change']}],
        address: [{required: true, message: "请输入通信地址", trigger: "blur"}],
        company_wish: [{required: true, message: "请输入入会后希望获得哪方面的支持和权益", trigger: "blur"}],
      },
      options: [{name: '普通联系人'}, {name: '首要联系人'}, {name: '重要联系人'}, {name: '商贸联系人'}], //联系人类型
      position: [{name: '在职'}, {name: '调岗'}, {name: '离职'}], //岗位状态
      pTypeOptions: [], // 产品类型
      nationalCityOptions: [],
      labelList: [], //商贸标签
      businessOption: [],
      partnerOption: [],
      productOption: [],
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      isShowOtherBusiness: false, //是否显示其他业务平台
      collapseTags: false,
      collapseAreaTags: false,
      contacts_type: [],
      contacts_station: [],
      mark: '',
      MemberLevelList: [],
      // 提交不可修改字段数组 2025年5月12日17:37:43 将单位名称 会员代表姓名，会员代表身份证号 先注释掉 变为可修改     京
      dis_field: [
        // 'company_name',
        // 'representative',
        // 'representative_IDCard'
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs['unit_memberForm'].clearValidate()
    })
    this.unit_memberForm = JSON.parse(JSON.stringify(this.form_data))
    this.form_disabled = this.unit_memberForm.audit_status != 0
    this.disa()
    this.getMemberBrandLists()
    this.getMemberLevel_lists()

    // this.contacts_type = JSON.parse(localStorage.getItem("dictdata")).contacts_type;
    // this.contacts_station = JSON.parse(localStorage.getItem("dictdata")).contacts_station;
    //
    // let userdata = JSON.parse(localStorage.getItem("userdata"));
    // this.userdata = userdata;
    // let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    // this.stepMenuList = stepMenuList;
    //
    // var index = stepMenuList.findIndex(function (item) {
    //   return item.link_url == "/conference";
    // });
    //
    // this.active = index;
    // this.type = this.$route.query.type;
    // this.mark = this.$route.query.mark;
    // this.contacts_long_id = this.$route.query.contacts_long_id;
    //
    //
    // let token = this.$store.state.token;
    // //console.log(token);
    // this.headers = {
    //   Authorization: token,
    // };
    //获取联系人信息
    // this.getInfor(this.contacts_long_id);
  },
  created() {
    // this.nationalCityOptions = area;
  },
  watch: {
    activeName(val) {
      if (val == 'brand') {
        this.getMemberBrandLists()
      }
    },
    form_data(val) {
      this.unit_memberForm = JSON.parse(JSON.stringify(val))
      this.form_disabled = this.unit_memberForm.audit_status != 0
      this.disa()

    }
  },
  methods: {
    disa() {
      if (this.unit_memberForm.audit_status != 0 && this.unit_memberForm.audit_status != 5) {
        this.SheetData.basic.forEach(item => {
          if (!item.title) {
            item.forEach(items => {
              let qq = this.dis_field.some(dis => {
                return dis == items.prop
              })
              if (qq) {
                items.disabled = true
              }
            })
          }
        })
      }
    },
    //预览图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = this.$imgOssUrl + url;
      this.dialogVisible = true;
    },
    // 获取企业类型
    getType() {
      companyType()
          .then((res) => {
            //console.log(res.data, '=====获取企业类型')
            if (res.code == 200) {
              let {data} = res;
              let arr = [];
              data.forEach((item) => {
                arr.push({
                  label: item.name,
                  value: item.itemid,
                });
              });
              this.options = arr;
            }
          })
          .catch((err) => {
            console.log(err, "==err");
          });
    },


    change_form_disabled() {
      this.form_disabled = !this.form_disabled
    },
    // 获取展商筛选项
    getOptionList() {
      optionList()
          .then((res) => {
            console.log(res, "====res");
            if (res.code == 200) {
              this.businessOption = res.data.bussinessList;
              this.partnerOption = res.data.partnerList;
              this.productOption = res.data.productList;
            }
          })
          .catch((err) => {
          });
    },
    getMemberBrandLists() {

      let data = this.$qs.stringify({
        page_no: this.page_no,
        page_size: this.page_size,
        type: this.unit_memberForm.type,
      });
      MemberBrandLists(data).then((res) => {
        if (res.code == 1) {

          this.tableData = res.data.lists;
          console.log(this.page_size, 'this.page_size')
          this.total = res.data.count
        }
      })
          .catch((err) => {
            console.log(err);
          });

    },
    // 操作产品标签
    pTypeHandle(type, index) {
      console.log(type, "=====type");
      let arr = this.unit_memberForm.productClass;
      if (type == "plus") {
        arr.push({productClass_1: ""});
      } else {
        this.$alert(`确定要移除吗？`, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
              arr.splice(index, 1);
            }
          },
        });
      }
      this.unit_memberForm.productClass = arr;
    },
    // 产品标签选择发生改变触发
    changePtype(val, index) {
      this.$set(this.unit_memberForm.productClass[index], "productClass_1", val);
      // let productClassChecked = this.unit_memberForm.productClass;
      // let isNew = true;
      // productClassChecked.forEach((item) => {
      //   if (item.productClass_1 == val) {
      //     this.$message.error("不可重复选择");
      //     isNew = false;
      //     return false;
      //   }
      // });
      // if (isNew) {
      //   this.$set(this.unit_memberForm.productClass[index], "productClass_1", val);
      // }else{
      //   this.$set(this.unit_memberForm.productClass[index], "productClass_1", '');
      // }
    },
    handleCheckedChange(value) {
      this.checkOnline_store = this.checkOnline_store.some(item => {
        return item == '无'
      }) ? ['无'] : this.checkOnline_store
      this.Clothing_Other = this.checkCategory.some(item => {
        return item == '其他服装品类'
      })
      this.Accessories_Other = this.checkCategory.some(item => {
        return item == '其他配饰品类'
      })
      this.E_commerce_Other = this.checkOnline_store.some(item => {
        return item == '其他'
      })
      this.brandForm.category = this.checkCategory
      this.brandForm.online_store = this.checkOnline_store
    },
    //zhao 上传成功
    handleSuccess(response, file, fileList, field) {
      if (response.code == 1) {
        this.$message.success(response.msg)
        this.unit_memberForm[field] = response.data.uri
      } else {
        this.$message.error(response.msg)
      }
    },
    // zhao 上传失败
    handleError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //zhao  删除图片
    handleRemove(field) {
      console.log(this.unit_memberForm[field])

      this.unit_memberForm[field] = ""
    },
    //赵 预览图片 通用
    handlePreview(file) {
      this.dialogImageUrl = this.$imgUrl + file;
      this.dialogVisible = true;
    },


    //zhao 上传成功
    trademarkSuccess(response, file, fileList, field) {
      this.brandForm.trademark = response.data.uri
    },
    // zhao 上传失败
    trademarkError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //zhao  删除品牌图片
    trademarkRemove(field) {
      this.brandForm.trademark = ""
    },
    //商贸标签操作
    changeLabel(index) {
      this.$set(this.labelList[index], "select", !this.labelList[index].select);
      let arr = this.labelList;
      let selectArr = [];
      arr.forEach((item) => {
        if (item.select) {
          selectArr.push({
            id: item.id,
            inputtime: item.inputtime,
            name: item.name,
          });
        }
      });
      this.unit_memberForm.business_label = selectArr;
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    //滑动到错误对应位置
    scrollToFormError() {
      // 获取第一个校验错误的元素
      const element = document.querySelectorAll(".el-form-item__error")[0];
      // 滚动到错误元素对应位置
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    handleMainProductChange(value) {
      this.collapseTags = value.length >= 5;
    },
    handleAreaChange(value) {
      this.collapseAreaTags = value.length >= 4;
    },
    // 提交
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },
    //保存草稿
    //   saveDraft(data) {
    //     this.loading = true;
    //     draft(data)
    //       .then((res) => {
    //         //console.log(res.data, "===保存草稿");
    //         this.loading = false;
    //         if (res.code == 200 && res.data.message == "成功") {
    //           this.$message.success("保存草稿成功！");
    //           // 刷新页面
    //           this.getInfor();
    //         } else {
    //           this.$message.warning(res.data.message);
    //         }
    //       })
    //       .catch((err) => {});
    //   },
    brandFormsave() {
      this.$refs['brandFormRef'].validate((valid) => {
        if (valid) {
          if (this.Clothing_Other) {
            this.checkCategory.forEach((item, index) => {
              if (item == '其他服装品类') {
                this.checkCategory[index] = item + '&' + this.Clothing_Other_text
              }
            })
          }
          if (this.Accessories_Other) {
            this.checkCategory.forEach((item, index) => {
              if (item == '其他配饰品类') {
                this.checkCategory[index] = item + '&' + this.Accessories_Other_text
              }
            })
          }
          if (this.E_commerce_Other) {
            this.checkOnline_store.forEach((item, index) => {
              if (item == '其他') {
                this.checkOnline_store[index] = item + '&' + this.E_commerce_Other_text
              }
            })
          }
          console.log(this.checkOnline_store);
          this.brandForm.category = this.checkCategory.join(',')
          this.brandForm.online_store = this.checkOnline_store.join(',')
          let data = JSON.parse(JSON.stringify(this.brandForm))
          data.type = this.unit_memberForm.type


          if (this.brandForm.id != '') {
            MemberBrand_edit(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.dialogFormVisible = false;
                this.getMemberBrandLists()
              }
            })
                .catch((err) => {
                  console.log(err);
                });
          } else {
            MemberBrand_add(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.dialogFormVisible = false;
                this.getMemberBrandLists()
              }
            })
                .catch((err) => {
                  console.log(err);
                });
          }
        }
      })


    },
    // 删除品牌
    delRow(row) {
      this.$confirm("确定要删除此条品牌数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            let data = {
              id: row.id
            }
            MemberBrand_delete(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.getMemberBrandLists()
              }
            }).catch((err) => {
              console.log(err);
            });
          })
    },
    //提交审核
    submitInfo() {
      this.loading = true;
      let data = this.unit_memberForm;
      data.mark = this.mark;
      if (this.type == 'add') {//新增
        this.addData(data)
      } else if (this.type == 'edit') {//修改
        this.editData(data)
      }

    },
    // 新增/编辑品牌
    changeBrand(type, row) {
      this.checkCategory = []
      this.checkOnline_store = []
      this.Clothing_Other = false
      this.Accessories_Other = false
      this.E_commerce_Other = false
      this.brandForm = {
        //品牌表单数据
        id: "",//品牌id
        ownership: "",//所属类型 1:个人会员，2:单位会员
        user_long_id: "",//所关联的用户长ID
        brand_name: "",//品牌名称
        website: "",//品牌官网
        brand_type: "",//品牌类别
        registration_time: "",//注册时间
        registration_address: "",//注册地
        trademark: [],//商标注册证或代理授权
        category: "",//品类
        offline_store: "",//线上分布/线上店铺
        online_store: "",//入驻电商平台
        SKU: "",//年sku数
        product_price: "",//产品及价位
        honors: "",//奖项及荣誉
      };
      if (type == 'add') {
        this.brandTitle = '新建品牌';
      } else {
        this.MemberBrandDetail(row)
        this.brandTitle = '编辑品牌';
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['brandFormRef'].clearValidate()
      })
    },
    MemberBrandDetail(row) {
      let data = this.$qs.stringify({id: row.id});
      MemberBrand_detail(data).then((res) => {
        if (res.code == 1) {
          this.checkCategory = res.data.category.split(',')
          this.checkOnline_store = res.data.online_store.split(',')

          this.checkCategory.forEach((item, index) => {
            if (item.includes('其他服装品类')) {
              this.Clothing_Other_text = item.substring(item.lastIndexOf("&") + 1)
              this.checkCategory[index] = item.substring(0, item.lastIndexOf("&"))
            }
          })
          this.checkCategory.forEach((item, index) => {
            if (item.includes('其他配饰品类')) {
              this.Accessories_Other_text = item.substring(item.lastIndexOf("&") + 1)
              this.checkCategory[index] = item.substring(0, item.lastIndexOf("&"))
            }
          })
          this.checkOnline_store.forEach((item, index) => {
            if (item.includes('其他')) {
              this.E_commerce_Other_text = item.substring(item.lastIndexOf("&") + 1)
              this.checkOnline_store[index] = item.substring(0, item.lastIndexOf("&"))
            }
          })
          this.Clothing_Other = this.checkCategory.some(item => {
            return item == '其他服装品类'
          })
          this.Accessories_Other = this.checkCategory.some(item => {
            return item == '其他配饰品类'
          })
          this.E_commerce_Other = this.checkOnline_store.some(item => {
            return item == '其他'
          })
          this.brandForm = res.data
        }
      })
          .catch((err) => {
            console.log(err);
          });

    },
    //新增
    addData(data) {

      addContacts(data).then((res) => {
        console.log(res.data, "===新增数据");
        this.loading = false;
        if (res.code == 1) {
          this.$message.success("新增联系人成功！");
          // 返回上一页
          setTimeout(() => {
            this.goBack();
          }, 1000);
        } else {
          this.$message.warning(res.data.message);
        }
      })
          .catch((err) => {
            this.loading = false;
          });
    },
    //编辑
    editData(data) {
      editContacts(data).then((res) => {
        console.log(res.data, "===修改数据");
        this.loading = false;
        if (res.code == 1) {
          this.$message.success("修改联系人成功！");
          // 返回上一页
          setTimeout(() => {
            this.goBack();
          }, 1000);
        } else {
          this.$message.warning(res.data.message);
        }
      })
          .catch((err) => {
            this.loading = false;
          });
    },
    // 分页相关
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page_no = val;
      this.getMemberBrandLists();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    // updateData(data) {
    //
    //   let form = JSON.parse(JSON.stringify(data))
    //
    //   form_data
    //   this.unit_memberForm = form
    //   this.getMemberBrandLists()
    // },
    validateForm() {
      let obj = {
        flag: false,
        firstInvalidField: ''
      }
      this.$refs['unit_memberForm'].validate((valid, object) => {
        obj.flag = valid
        obj.firstInvalidField = Object.keys(object)[0];

      })
      return obj
    },
    // 获取会员等级
    getMemberLevel_lists() {
      let id = this.unit_memberForm.committee_id;
      let data = this.$qs.stringify({committee_id: id});
      return MemberLevel_lists(data).then((res) => {
        if (res.code == 1) {
          this.MemberLevelList = res.data.lists;
        } else {
          this.$message.warning(res.msg);
        }
      }).catch((error) => {
        // 处理可能出现的错误
        console.error('Error fetching member level lists:', error);
        throw error;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__content {
  display: block !important;
}

.content {
  padding-bottom: 40px;

  .main-title {

  }

  //  .unit_member_class{
  //    display: flex;
  //    flex-wrap: wrap;
  //    //margin-bottom: 100px;
  //    width: 100%;
  //    //background: #fff;
  //    //padding: 40px;
  //    box-sizing: border-box;
  //
  //    .el-form-item {
  //      //width: 27%;
  //      //margin-right: 60px;
  //
  //      .el-select,
  //      .el-cascader {
  //        width: 100%;
  //      }
  //
  //      .el-input__inner {
  //        height: 50px;
  //        line-height: 50px;
  //      }
  //
  //      .el-tag {
  //        min-width: 100px;
  //        height: 38px;
  //        color: #48484a;
  //        margin-right: 8px;
  //        margin-bottom: 8px;
  //        font-size: 12px;
  //        line-height: 38px;
  //        text-align: center;
  //        background: #fff;
  //        border-radius: 6px;
  //        cursor: pointer;
  //        border: 1px solid #e0e0e0;
  //      }
  //
  //      .select {
  //        color: #1677ff;
  //        border-color: #1677ff;
  //      }
  //
  //      .el-textarea__inner {
  //        border-radius: 9px;
  //      }
  //    }
  //
  //    .form-width {
  //      width: 80%;
  //    }
  //
  //    .form-label {
  //      .el-tag + .el-tag {
  //        margin-left: 10px;
  //        margin-bottom: 10px;
  //      }
  //
  //      .button-new-tag,
  //      .input-new-tag {
  //        width: 200px;
  //        height: 50px;
  //        color: #48484a;
  //        display: inline-block;
  //        margin-right: 8px;
  //        font-size: 18px;
  //        line-height: 50px;
  //        text-align: center;
  //        background: #fff;
  //        border-radius: 9px;
  //        border: 1px solid #e0e0e0;
  //      }
  //
  //      .input-new-tag {
  //        border: 0 none;
  //      }
  //    }
  //
  //    .product-class {
  //      align-items: center;
  //
  //      .el-select {
  //        width: 200px;
  //        margin-right: 12px;
  //      }
  //
  //      .el-button {
  //        min-width: auto;
  //        width: 23px;
  //        height: 23px;
  //        font-size: 12px;
  //        text-align: center;
  //        line-height: 23px;
  //        padding: 0;
  //        position: inherit;
  //        transform: none;
  //        border-radius: 50%;
  //      }
  //
  //      .el-button + .el-button {
  //        margin-left: 20px;
  //      }
  //
  //      .el-button--danger {
  //        color: #fff !important;
  //        background-color: #f56c6c !important;
  //        border-color: #f56c6c !important;
  //      }
  //
  //      .el-button--primary {
  //        color: #fff !important;
  //        background-color: #409eff !important;
  //        border-color: #409eff !important;
  //      }
  //    }
  //
  //    .product-class + .product-class {
  //      margin-top: 20px;
  //    }
  //  }
  //}

  .bus-btn {
    text-align: center;

    .el-button {
      position: inherit;
      transform: translateX(0);
    }

    .save-draft {
      color: #2690E6;
      background: #fff;
      border: 1px solid #008DFF;
    }
  }
}
</style>
<style lang="scss" scoped>
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }

  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

.selitem {
  width: 100%;
}

.unit_member_class.el-form-item {
  .el-form-item__label,
  .el-form-item__content {
    font-size: 14px !important;
    color: #7F8FA4 !important;
    font-weight: 400 !important;
  }

  .el-input__inner {
    margin-top: 7px;
    height: 38px;
    font-size: 12px;
    line-height: 38px;
    border-radius: 6px;
    border-color: #e0e0e0;
  }
}

.avatar-uploader {
  width: 152px;
  height: 152px;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 2px;
  border: 1px dashed #bfbfbf;

  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .add-wrap {
    line-height: 25px;
    color: #8c8c8c;
    font-size: 12px;

    .title {
      color: #434343;
      font-size: 16px;
    }

    .el-icon-plus {
      font-size: 40px;
      color: #999;
      margin: 20px auto 10px;
    }
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    max-width: 175px;
    max-height: 175px;
    display: block;
  }

  .upload-img {
    .upload-span {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: all 0.1s;

      .upload-icon {
        color: #fff;
        font-size: 36px;
      }
    }

    &:hover {
      .upload-span {
        opacity: 1;
      }
    }
  }
}

.poster-uploader {
  width: 384px;
  overflow: hidden;
  background: #fff;
  border-radius: 9px;
  border: 1px solid #bfbfbf;

  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .add-wrap {
    line-height: 25px;
    color: #8c8c8c;
    font-size: 12px;

    .title {
      color: #434343;
      font-size: 16px;
    }

    .el-icon-tickets {
      font-size: 40px;
      color: #1677ff;
      margin: 20px auto 10px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .el-button {
    font-size: 15px !important;
  }
  .content {
    padding: 30px 0 80px 0 !important;

    .unit_member_class {
      margin: auto;
      width: 90% !important;

      //.el-form-item {
      //  width: 100% !important;
      //  margin-right: 0 !important;
      //}
    }

    .go-back {
      margin-left: 30px;
    }

    .main-title {
      margin-left: 30px;
    }
  }


}

.el-upload__tip {
  margin: 0;
  color: #A9ABBA;
}

.unit_member_class {
  margin-top: 30px;

  .form_item {
    width: 100%;
  }

}

.unit_member_class .el-row {
  display: flex;
  justify-content: center;
}

.el-date-editor {
  width: 100% !important;
}

/deep/ .el-form-item {
  margin-bottom: 15px !important;
}

.searchBtnBox {
  display: flex;
}
</style>